export function parseHexToRgba (hex) {
  if (!hex || typeof hex !== 'string') return { r: 0, g: 0, b: 0, a: 1 }

  let h = hex.trim().replace(/^#/, '').replace(/^0x/i, '').replace(/[\s_]/g, '')
  if (!/^[0-9a-fA-F]{3,4}$|^[0-9a-fA-F]{6}([0-9a-fA-F]{2})?$/.test(h)) {
    return { r: 0, g: 0, b: 0, a: 1 }
  }

  if (h.length === 3 || h.length === 4) {
    h = h
      .split('')
      .map((ch) => ch + ch)
      .join('')
  }

  const r = parseInt(h.slice(0, 2), 16)
  const g = parseInt(h.slice(2, 4), 16)
  const b = parseInt(h.slice(4, 6), 16)
  const a = h.length === 8 ? parseInt(h.slice(6, 8), 16) / 255 : 1

  return { r, g, b, a }
}

export function relativeLuminance ({ r, g, b }) {
  const toLinear = (v) => {
    const c = v / 255
    return c <= 0.04045 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4)
  }
  const R = toLinear(r)
  const G = toLinear(g)
  const B = toLinear(b)
  return 0.2126 * R + 0.7152 * G + 0.0722 * B
}

export function blendOver (fg, bg) {
  const a = fg.a ?? 1
  return {
    r: Math.round(fg.r * a + bg.r * (1 - a)),
    g: Math.round(fg.g * a + bg.g * (1 - a)),
    b: Math.round(fg.b * a + bg.b * (1 - a))
  }
}

function compositeOverFloat (fg, bg) {
  const af = fg.a ?? 1
  const ab = bg.a ?? 1
  const aOut = af + ab * (1 - af)
  if (aOut === 0) return { r: 0, g: 0, b: 0, a: 0 }

  const r = (fg.r * af + bg.r * ab * (1 - af)) / aOut
  const g = (fg.g * af + bg.g * ab * (1 - af)) / aOut
  const b = (fg.b * af + bg.b * ab * (1 - af)) / aOut
  return { r, g, b, a: aOut }
}

export function contrastRatio (fgHex, bgHex = '#FFFFFF') {
  let fg = parseHexToRgba(fgHex)
  let bg = parseHexToRgba(bgHex)

  if (bg.a < 1) {
    bg = compositeOverFloat(bg, { r: 255, g: 255, b: 255, a: 1 })
  }

  if (fg.a < 1) {
    fg = compositeOverFloat(fg, bg)
    fg.a = 1
  }

  const L1 = relativeLuminance(fg)
  const L2 = relativeLuminance(bg)
  const lighter = Math.max(L1, L2)
  const darker = Math.min(L1, L2)
  return (lighter + 0.05) / (darker + 0.05)
}

export function meetsAA (fgHex, bgHex = '#FFFFFF', threshold = 4.6) {
  return contrastRatio(fgHex, bgHex) >= threshold
}
